export default {
  Detail: {
    AccountingObjectName: 'Người thực hiện',
    StockKeeperInward: 'Thủ kho nhập',
    StockKeeperOutward: 'Thủ kho xuất',
    VoucherRef: 'CT tham chiếu',
    VoucherReference: 'Chứng từ tham chiếu',
    RefDate: 'Ngày CT',
    ReferenceDate: 'Ngày chứng từ',
    PostedDate: 'Ngày HT',
    PostedDateTitle: 'Ngày hạch toán',
    RefNo: 'Số CT',
    ReferenceNo: 'Số chứng từ',

    Warning: {
      MissCCDCInfo: 'Chưa nhập vật tư tại dòng {0}.',
      MissFromStock: 'Chưa nhập từ kho.',
      MissToStock: 'Chưa nhập đến kho.',
      DuplicateStock: 'Kho chuyển đi và kho chuyển đến không được trùng nhau.',
    },
  },
};
